import React from "react";
import "./index.css";
import "./theme.css";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

global.platform = Capacitor.getPlatform();

const index = async () => {
    document.body.className = localStorage.getItem("theme") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    createRoot(document.getElementById("root")).render(
        <Router>
            <App />
        </Router>
    );
};
index();
